<template>
  <div>
    <h1>User terms and conditions page</h1>

    <p>
      Terms and conditions content
    </p>
  </div>
</template>

<script>
export default {
  loading: false
}
</script>
